import React, { ReactNode } from 'react';
import { SearchX, ArrowLeft } from 'lucide-react';
import Button from './Button';
import { IconTooltip } from './IconTooltip';

interface NoDataFoundProps {
    title?: string;
    description?: string;
    icon?: ReactNode;
    actionLabel?: string;
    onAction?: () => void;
}

export const NoDataFound: React.FC<NoDataFoundProps> = ({
    title = "Data Not Found",
    description = "The resource looking for might have been moved or doesn't exist.",
    icon,
    actionLabel = "Go Back",
    onAction
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-20 px-6 text-center animate-in fade-in zoom-in duration-500">
            <IconTooltip content={title}>
                <div className="mb-6 w-20 h-20 bg-secondary/30 rounded-full flex items-center justify-center text-muted-foreground/30">
                    {icon || <SearchX className="w-10 h-10 shrink-0" />}
                </div>
            </IconTooltip>
            <h2 className="text-2xl font-bold text-foreground mb-2 leading-tight tracking-tight">{title}</h2>
            <p className="text-muted-foreground max-w-sm mb-8 leading-relaxed text-sm">
                {description}
            </p>
            {onAction && (
                <Button
                    onClick={onAction}
                    className="gap-2 px-6 font-semibold"
                    variant="primary"
                    leftIcon={<ArrowLeft className="w-4 h-4" />}
                >

                    {actionLabel}
                </Button>
            )}
        </div>
    );
};
